<template>
  <div class="media white">
    <v-container>
      <v-row class="px-8">
        <v-row>
          <v-col cols="1" class="hidden-sm-and-up mx-0 px-0">
            <filter-menu>
              <v-expansion-panel
                slot="accordion-content"
                v-for="(year, yearKey) in years"
                :key="yearKey"
                active-class="accent--text active-year"
              >
                <v-expansion-panel-header color="transparent" @click="getArticlesYear(yearKey)">
                  <h1>{{ year.name }}</h1>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  color="transparent"
                >
                  <v-list :key="expansionPanelComponentKey">
                    <span
                      v-for="(month, monthKey) in year.months"
                      :key="monthKey"
                    >
                      <v-list-item v-if="month.articles.length" @click="showArticles(month.articles)">
                        {{ month.name }} ({{ month.articles.length }})
                      </v-list-item>
                    </span>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </filter-menu>
          </v-col>

          <v-col cols="6" sm="8" md="8" lg="8" xl="8">
            <div :class="[ $vuetify.breakpoint.xs ? 'display-1' : 'display-2', 'font-weight-black primary--text' ]">
              <span>Media</span>
            </div>
          </v-col>

          <v-col cols="5" sm="4" md="4" lg="4" xl="4" align-self="end">
            <h2 class="primary--text text-right">Articles</h2>
          </v-col>
        </v-row>
      </v-row>

      <base-horizontal-line></base-horizontal-line>
      
      <v-row class="pt-10">
        <v-col cols="3" class="hidden-sm-and-down">
          <v-expansion-panels
            accordion
            flat
          >
            <v-expansion-panel
              v-for="(year, yearKey) in years"
              :key="yearKey"
              active-class="accent--text active-year"
            >
              <v-expansion-panel-header color="transparent" @click="getArticlesYear(yearKey)">
                <h1>{{ year.name }}</h1>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                color="transparent"
              >
                <v-list :key="expansionPanelComponentKey">
                  <span
                    v-for="(month, monthKey) in year.months"
                    :key="monthKey"
                  >
                    <v-list-item v-if="month.articles.length" @click="showArticles(month.articles)">
                      {{ month.name }} ({{ month.articles.length }})
                    </v-list-item>
                  </span>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col
          cols="12" sm="12" md="9" lg="9" xl="9"
        >
          <template v-if="articles.length">
            <div v-for="(article, key) in articles" :key="key" class="card pb-10">
              <article-content
                :id="article.id"
                :title="article.title"
                :dateCreated="article.dateCreated"
                :backgroundImage="article.backgroundImage"
                :description="article.description"
              ></article-content>
            </div>
          </template>
          <template v-else>
            <v-row justify="center" align="center" class="fill-height">
              <div class="text-center">
                <v-row justify="center">
                  <div>
                    <v-img src="@/assets/images/caution.png" width="100"></v-img>
                  </div>
                </v-row>
                <div class="display-1 grey--text pt-3">No records found</div>
              </div>
            </v-row>
          </template>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment';
import ArticleContent from "@/components/media/ArticleContent.vue";
import FilterMenu from "@/components/media/FilterMenu.vue";

import Repository from "@/api/repositories";
const MediaArticlesApi = Repository.get("mediaArticles");

export default {
  name: "Media",
  components: {
    ArticleContent,
    FilterMenu,
  },
  data() {
    return {
      currentMonth: null,
      articles: [],
      allArticles: [],
      years: [],
      months: [
        { name: "January", number: 1 },
        { name: "February", number: 2 },
        { name: "March", number: 3 },
        { name: "April", number: 4 },
        { name: "May", number: 5 },
        { name: "June", number: 6 },
        { name: "July", number: 7 },
        { name: "August", number: 8 },
        { name: "September", number: 9 },
        { name: "October", number: 10 },
        { name: "November", number: 11 },
        { name: "December", number: 12 }
      ].reverse(),
      expansionPanelComponentKey: 0
		}
  },
  async mounted() {
    await this.getRecentYears(3);
    await this.getCurrentYearArticles(this.years[0].name);
  },
  methods: {
    getRecentYears(number) {
      let yearNow = moment().format("Y");

      for (let index = 0; index < number; index++) {
        this.years.push({
          name: yearNow--
        });
      }
    },
    async getArticlesYear(yearKey) {
      let year = this.years[yearKey];

      if (!year.months) {
        let params = {
          year: year.name,
          order_by: "DESC"
        };

        let {
          data: {
            data: articles
          }
        } = await MediaArticlesApi.get({ params });

        articles = articles.map(item => {
          item.dateCreated = moment(item.post_date).format("Do MMMM YYYY");
          item.backgroundImage = item.background_image.main || null;

          return item;
        });

        let monthArticles = this.months.map(item => {
          let filteredArticles = articles.filter(article => moment(article.post_date).format("MMMM") === item.name);

          return {
            ...item,
            articles: [...filteredArticles]
          };
        });

        year.months = monthArticles;

        this.expansionPanelComponentKey++;
      }
    },
    showArticles(articles) {
      this.articles = articles;
    },
    async getCurrentYearArticles(year) {
      let params = {
          year,
          order_by: "DESC"
        };

        let {
          data: {
            data: articles
          }
        } = await MediaArticlesApi.get({ params });

        articles = articles.map(item => {
          item.dateCreated = moment(item.post_date).format("Do MMMM YYYY");
          item.backgroundImage = item.background_image.main || null;

          return item;
        });

      this.articles = articles;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.media {
  padding: 150px 20px 120px 20px;

  .read-more {
    cursor: pointer;
  }

  .active-year {
    .v-expansion-panel-header__icon {
			.v-icon {
				color: $accent-blue !important;
			}
		}
  }

  .active-month {
    color: $accent-blue !important;
  }
}
</style>